import styled, { css } from 'styled-components';
import { breakpoint } from '../theme/breakpoint';

import { Card } from '../card-with-icon/styles';

export const CardRow = styled.div`
  display: flex;
  flex-direction: column;

  ${breakpoint.tablet`
    flex-direction: row;
    justify-content: space-between;
  `};

  ${Card} {
    display: flex;

    ${breakpoint.tablet`
      ${({ $cardsCount, theme }) =>
        $cardsCount &&
        css`
          flex: 0 1;
          flex-basis: calc(
            ${Math.floor(100 / $cardsCount)}% - ${theme.spacing.tiny}
          );
        `}
    `};
  }
`;
